function getDd ({nameLet, telLet, kitchenLet, roomLet, hallLet, bathroomLet, electricaLet, plumbingLet, totalKitchen, floorWhiteLetKitchen, floorBlackLetKitchen, flooringLetKitchen, floorinfSelectedKitchen, floorSquereKitchen, walsWhiteLetKitchen, walsWhiteSelectedKitchen, walsBlackLetKitchen, walsBlackSelectedKitchen, walsFinishingletKitchen, walsFinishingSelectedKitchen, walsSquereKitchen, ceilingWhiteLetKitchen, ceilingWhiteSelectedKitchen, ceilingBlackLetKitchen,  ceilingBlackSelectedKitchen, ceilingPaintingLetKitchen, ceilingSquereKitchen, numberRooms, totalRooms, floorWhiteLetRooms, floorBlackLetRooms, flooringLetRooms, floorinfSelectedRooms, allFloorSquereRooms, walsWhiteLetRooms, walsWhiteSelectedRooms, walsBlackLetRooms, walsBlackSelectedRooms, walsFinishingletRooms, walsFinishingSelectedRooms, walsSquereRooms, ceilingWhiteLetRooms, ceilingWhiteSelectedRooms, ceilingBlackLetRooms,  ceilingBlackSelectedRooms, ceilingPaintingLetRooms, ceilingSquereRooms, totalHall, floorWhiteLetHall, floorBlackLetHall, flooringLetHall, floorinfSelectedHall, floorSquereHall, walsWhiteLetHall, walsWhiteSelectedHall, walsBlackLetHall, walsBlackSelectedHall, walsFinishingletHall, walsFinishingSelectedHall, walsSquereHall, ceilingWhiteLetHall, ceilingWhiteSelectedHall, ceilingBlackLetHall,  ceilingBlackSelectedHall, ceilingPaintingLetHall, ceilingSquereHall, floorSquereBath, floorBlackLetBath, floorWhiteLetBath, flooringLetBath,  wallsBlackLetBath,  wallsFinishingletBath, wallsSquereBath, cealingLetBath, ceilingSelectedBath, ceilingSquereBath, totalBath, electricPanel, switchAndSocket, switchAndSocketNumber, lightnessLet, numberOfChandlier, totalElectric, tubingLet, tubingPlusLet, bathtubLet, bathtubNumLet, showerCabinLet, showerCabinNumLet, palletLet, palletNumLet, showerHeadLet, showerHeadNumLet,  dishwasherLet, dishwasherNumberLet, sinkLet, sinkNumberLet, hygienicShowerLet, hygienicShowerNumberLet, tapLet, tapNumberLet, toiletLet, toiletNumberLet, dryerLet, dryerNumberLet, washerLet, washerNumberLet, plumbingTotalLet }) {



    function getBoolean(work) {
        if(!work > 0 ) {
            return false;
        } else {
            return true;
        }
    }

    function getTotal(text, total) {
        return [{text: `Итого ${text}`, style: 'tableHeader', colSpan: 5, alignment: 'right', color: '#1261AB', bold: true}, {},{}, {}, {}, {text: `${total}`, alignment: 'center', color: '#1261AB', bold: true}]
    }

    function getSevenArrays(header, name1, coast1, name2, coast2, name3, coast3, name4, coast4, name5, coast5, name6, coast6, area, measure, backColor) {
        return [
            [{text: header, style: 'tableHeader', colSpan: 6, alignment: 'center', fillColor: backColor}, {}, {}, {}, {}, {}],
            ['1', name1, `${measure}`, ` ${area}`, `${coast1}`, ` ${area*coast1}`],
            ['2', name2, `${measure}`, ` ${area}`, `${coast2}`, ` ${area*coast2}`],
            ['3', name3, `${measure}`, ` ${area}`,`${coast3}`, ` ${area*coast3}`],
            ['4', name4, `${measure}`, ` ${area}`, `${coast4}`, ` ${area*coast4}`],
            ['5', name5, `${measure}`, ` ${area}`, `${coast5}`, ` ${area*coast5}`],
            ['6', name6, `${measure}`, ` ${area}`, `${coast6}`, ` ${area*coast6}`]
        ]
         
    }

    function getFiveArrays(header, name1, coast1, name2, coast2, name3, coast3, name4, coast4, area, measure, backColor) {
        return [
            [{text: header, style: 'tableHeader', colSpan: 6, alignment: 'center', fillColor: backColor}, {}, {}, {}, {}, {}],
            ['1', name1, `${measure}`, ` ${area}`, `${coast1}`, ` ${area*coast1}`],
            ['2', name2, `${measure}`, ` ${area}`, `${coast2}`, ` ${area*coast2}`],
            ['3', name3, `${measure}`, ` ${area}`,`${coast3}`, ` ${area*coast3}`],
            ['4', name4, `${measure}`, ` ${area}`, `${coast4}`, ` ${area*coast4}`]
        ]
         
    }

    function getFoureArrays(header, name1, coast1, name2, coast2, name3, coast3, area, measure, backColor) {
        return [
            [{text: header, style: 'tableHeader', colSpan: 6, alignment: 'center', fillColor: backColor}, {}, {}, {}, {}, {}],
            ['1', name1, `${measure}`, ` ${area}`, `${coast1}`, ` ${area*coast1}`],
            ['2', name2, `${measure}`, ` ${area}`, `${coast2}`, ` ${area*coast2}`],
            ['3', name3, `${measure}`, ` ${area}`,`${coast3}`, ` ${area*coast3}`],
        ]
         
    }

    function getThreeArrays(header, name1, coast1, name2, coast2, area, measure, backColor) {
        return  [
            [{text: header, style: 'tableHeader', colSpan: 6, alignment: 'center', fillColor: backColor}, {}, {}, {}, {}, {}],
            ['1', name1, `${measure}`, ` ${area}`, `${coast1}`, ` ${area*coast1}`],
            ['2', name2, `${measure}`, ` ${area}`, `${coast2}`, ` ${area*coast2}`]
        ]
    }

    function getTwoArrays(header, name1, coast1, area, measure, backColor) {
        return  [
            [{text: header, style: 'tableHeader', colSpan: 6, alignment: 'center', fillColor: backColor}, {}, {}, {}, {}, {}],
            ['1', name1, `${measure}`, ` ${area}`, `${coast1}`, ` ${area*coast1}`]
        ]
    }

    // Kitchen
    // floor

    let florAreaKitchen = floorSquereKitchen,
       blakFloorWorksKitchen = getBoolean(floorBlackLetKitchen),
       whiteFloorWorksKitchen = getBoolean(floorWhiteLetKitchen),
       flooringFloorWorksKitchen = getBoolean(flooringLetKitchen),
       linoleumKitchen = floorinfSelectedKitchen === 'Линолиум' ? true : false,
       lamParketKitchen = floorinfSelectedKitchen === 'Ламинированый паркет' ? true : false,
       parketKitchen = floorinfSelectedKitchen === 'Паркетная доска' ? true : false,
       floorTileKitchen = floorinfSelectedKitchen === 'Напольная плитка керамогранит' ? true : false;

    // Black works 
    let floorBlakWorksKitchen = blakFloorWorksKitchen ? getFiveArrays(`Черновые работы`,'Грунтовка пола (1 слой) «бетоконтактом»', 80, 'Засыпка керамзитом', 100, 'Настил плёнки гидроизоляционной', 50, 'Стяжка пола толщиной до 30 мм (ЦПС) с установкой маяков', 500, florAreaKitchen, 'м2', '#DBE7F2') : [[{colSpan: 6, rowSpan: 5, text: 'Черновые работы: нет'}, {},{},{},{},{}],['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',]];
    // White works 
    let floorWhiteWorksKitchen = whiteFloorWorksKitchen ? getThreeArrays('Чистовое выравнивание', 'Нанесение пропиточного грунта (2 слоя) на существующее основание (ЦПС / сухая стяжка)', 70, 'Выравнивание пола финишным нивеллиром до 20 мм (наливной пол)', 260, florAreaKitchen, 'м2', '#DBE7F2'): [[{colSpan: 6, rowSpan: 3, text: 'Чистовое выравнивание: нет'}, {},{},{},{},{}],['', '','','','','',], ['', '','','','','',]];

    // flooring
        // linoleum
    let linoleumItemKitchen = linoleumKitchen ? getThreeArrays(`Линолиум`, 'Обеспыливание пола (перед настилом напольных покрытий)', 40, 'Настил линолеума', 250, florAreaKitchen, 'м2', '') : [[{colSpan: 6, rowSpan: 3, text: 'Линолиум: нет'}, {},{},{},{},{}],['', '','','','','',], ['', '','','','','',]];

        // lamparket
    let lamParketItemKitchen = lamParketKitchen ? getFoureArrays(`Ламинированый паркет`, 'Обеспыливание пола (перед настилом напольных покрытий)', 40, 'Настил подложки листовой, пробковой, хвойной', 50, 'Настил ламината бесшовного', 400, florAreaKitchen, 'м2', ' ') : [[{colSpan: 6, rowSpan: 4, text: 'Ламинированый паркет: нет'}, {},{},{},{},{}],['', '','','','','',], ['', '','','','','',], ['', '','','','','',]];

        // parket
    let  parketItemKitchen =  parketKitchen ? getThreeArrays(`Паркетная доска`, 'Обеспыливание пола (перед настилом напольных покрытий)', 40, 'Настил паркетной доски плавающим образом', 450, florAreaKitchen, 'м2', '') : [[{colSpan: 6, rowSpan: 3, text: 'Паркетная доска: нет'}, {},{},{},{},{}],['', '','','','','',], ['', '','','','','',]];

        // tile
    let  floorTileItemKitchen =  floorTileKitchen ? getThreeArrays(`Напольная плитка керамогранит`, 'Обеспыливание пола (перед настилом напольных покрытий)', 40, 'Укладка керамической плитки на пол/стены: размер 200х300, 300х300, 400х250, 400х400, 500х300, 500х500 мм', 1200, florAreaKitchen, 'м2', '') : [[{colSpan: 6, rowSpan: 3, text: 'Напольная плитка керамогранит: нет'}, {},{},{},{},{}],['', '','','','','',], ['', '','','','','',]];

    let floorFlooringWorksKitchen = flooringFloorWorksKitchen ? [
        [{text: `Напольное покрытие`, style: 'tableHeader', colSpan: 6, alignment: 'center', fillColor: '#DBE7F2'}, {}, {}, {}, {}, {}],
        linoleumItemKitchen[0],
        linoleumItemKitchen[1],
        linoleumItemKitchen[2],
        lamParketItemKitchen[0],
        lamParketItemKitchen[1],
        lamParketItemKitchen[2],
        lamParketItemKitchen[3],
        parketItemKitchen[0],
        parketItemKitchen[1],
        parketItemKitchen[2],
        floorTileItemKitchen[0],
        floorTileItemKitchen[1],
        floorTileItemKitchen[2]
    ] : [[{colSpan: 6, rowSpan: 14, text: 'Напольное покрытие: нет'}, {},{},{},{},{}],['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',]];

    // Kitchen
    // wals
    let walsAreaKtchen = walsSquereKitchen,
        blackWalsWorksKitchen = getBoolean(walsBlackLetKitchen),
        plasterKitchen =  walsBlackSelectedKitchen === 'Штукатурные стены' ? true : false,
        gypsumPlasterboardKitchen =  walsBlackSelectedKitchen === 'Гипрочные стены' ? true : false,
        whiteWalsWorksKitchen = getBoolean(walsWhiteLetKitchen),
        forWallpaperKitchen = walsWhiteSelectedKitchen === 'Под обои' ? true : false,
        forPaintingKitchen = walsWhiteSelectedKitchen === 'Под покраску' ? true : false,
        finishWalsWorksKitchen = getBoolean(walsFinishingletKitchen),
        paintingKitchen = walsFinishingSelectedKitchen === 'Покраска стен в 2 слоя' ? true : false,
        wallpaperingKitchen = walsFinishingSelectedKitchen === 'Поклейка обоев' ? true : false;

    // Black works 
        // plaster
    let plasterItemKitchen = plasterKitchen ? getFoureArrays(`Штукатурные стены`, 'Грунтовка стен (1 слой)', 40, 'Выравнивание стен гипсовой штукатурной смесью по маякам до 30 мм', 120, 'Монтаж маяков', 400, walsAreaKtchen, 'м2', '') : [[{colSpan: 6, rowSpan: 4, text: 'Штукатурные стены: нет'}, {},{},{},{},{}],['', '','','','','',], ['', '','','','','',], ['', '','','','','',]];

        // gypsum PlasterboardKitchen
    let  gypsumPlasterboardItemKitchen=  gypsumPlasterboardKitchen ? getThreeArrays(`Гипрочные стены`, 'Устройство ГКЛ фальш стены в 1 слой (возведение одностороннего металлокаркаса с обшивкой ГКЛ в 1 слой с одной стороны)', 550, 'Заделка стыков на потолочных листах гипсокартона и отверстий от саморезов (подготовка к нанесению шпатлёвки)', 50, walsAreaKtchen, 'м2', '') : [[{colSpan: 6, rowSpan: 3, text: 'Гипрочные стены: нет'}, {},{},{},{},{}],['', '','','','','',], ['', '','','','','',]];

    // Black works  
    let walsBlackWorksKitchen = blackWalsWorksKitchen ? [
        [{text: `Черновые работы`, style: 'tableHeader', colSpan: 6, alignment: 'center', fillColor: '#DBE7F2'}, {}, {}, {}, {}, {}],
        plasterItemKitchen[0],
        plasterItemKitchen[1],
        plasterItemKitchen[2],
        plasterItemKitchen[3],
        gypsumPlasterboardItemKitchen[0],
        gypsumPlasterboardItemKitchen[1],
        gypsumPlasterboardItemKitchen[2],
    ] : [[{colSpan: 6, rowSpan: 8, text: 'Черновые работы: нет'}, {},{},{},{},{}],['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',]];

    // White works 
        // for Wallpaper
    let forWallpaperItemKitchen = forWallpaperKitchen ?  getThreeArrays(`Под обои`, 'Шпатлёвка стен под обои, стеклохолст, декоративные элементы в 2 слоя', 280, 'Ошкуривание стен', 100, walsAreaKtchen, 'м2', '') : [[{colSpan: 6, rowSpan: 3, text: 'Под обои: нет'}, {},{},{},{},{}],['', '','','','','',], ['', '','','','','',]];
 
        //  for Painting 
    let  forPaintingItemKitchen =  forPaintingKitchen  ? getFiveArrays(`Под покраску`,'Шпатлёвка стен под обои, стеклохолст, декоративные элементы в 2 слоя', 280, 'Шпатлёвка стен под покраску в 2 слоя (финишная шпатлёвка SheetRock)', 320, 'Поклейка стеклохолста на стену (требуется при подготовке стен под покраску)', 200, 'Ошкуривание стен', 100, walsAreaKtchen, 'м2', ' ') : [[{colSpan: 6, rowSpan: 5, text: 'Под покраску: нет'}, {},{},{},{},{}],['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',]];

    // White works  
    let walsWhiteWorksKitchen = whiteWalsWorksKitchen ? [
        [{text: `Чистовое выравнивание`, style: 'tableHeader', colSpan: 6, alignment: 'center', fillColor: '#DBE7F2'}, {}, {}, {}, {}, {}],
        forWallpaperItemKitchen[0],
        forWallpaperItemKitchen[1],
        forWallpaperItemKitchen[2],
        forPaintingItemKitchen[0],
        forPaintingItemKitchen[1],
        forPaintingItemKitchen[2],
        forPaintingItemKitchen[3],
        forPaintingItemKitchen[4],
    ] : [[{colSpan: 6, rowSpan: 9, text: 'Чистовое выравнивание: нет'}, {},{},{},{},{}],['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',]];

    // Finishing works 
        // for Wallpaper
    let paintingItemKitchen = paintingKitchen ?  getTwoArrays(`Покраска`, `Покраска стен в 2 слоя`, 260, walsAreaKtchen, 'м2', '') : [[{colSpan: 6, rowSpan: 2, text: 'Покраска: нет'}, {},{},{},{},{}],['', '','','','','',]];
 
        //  wallpapering
    let  wallpaperingItemKitchen =  wallpaperingKitchen  ? getTwoArrays(`Поклейка обоев`, `Оклейка стен бумажными, виниловыми, флизелиновыми обоями с подгонкой рисунка (стоимостью до 1500р / рулон — 1ая категория стоимости)`, 360, walsAreaKtchen, 'м2', '') : [[{colSpan: 6, rowSpan: 2, text: 'Поклейка обоев: нет'}, {},{},{},{},{}],['', '','','','','',]];

    // Finishing works  
    let walsfinisWorksKitchen = finishWalsWorksKitchen ? [
        [{text: `Отделка`, style: 'tableHeader', colSpan: 6, alignment: 'center', fillColor: '#DBE7F2'}, {}, {}, {}, {}, {}],
        paintingItemKitchen[0],
        paintingItemKitchen[1],
        wallpaperingItemKitchen[0],
        wallpaperingItemKitchen[1],
    ] : [[{colSpan: 6, rowSpan: 5, text: 'Отделка: нет'}, {},{},{},{},{}],['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',]];

   // Kitchen
    // ceiling

    let ceilingAreaKitchen = ceilingSquereKitchen,
        blakCeilingWorksKitchen = getBoolean(ceilingBlackLetKitchen),
        plasterCeilingKitchen = ceilingBlackSelectedKitchen === 'Штукатурные потолки' ? true : false,
        stretchCeilingKitchen = ceilingBlackSelectedKitchen === 'Натяжные потолки' ? true : false,
        gypsumCeilingKitchen = ceilingBlackSelectedKitchen === 'Гипрочные потолки' ? true : false,
        whiteCeilingWorksKitchen = getBoolean(ceilingWhiteLetKitchen),
        forPlasterCeilingKitchen = ceilingWhiteSelectedKitchen === 'При штукатурке' ? true : false,
        forGypsumCeilingKitchen = ceilingWhiteSelectedKitchen === 'При гипроке' ? true : false,
        paintingCeilingWorksKitchen = getBoolean(ceilingPaintingLetKitchen);

        // Black works 
            // plaster Ceiling
        let plasterCeilingItemKitchen = plasterCeilingKitchen ? getFoureArrays(`Штукатурные потолки`, 'Грунтовка стен (1 слой)', 50, 'Выравнивание стен гипсовой штукатурной смесью по маякам до 30 мм', 550, 'Монтаж маяков', 130, ceilingAreaKitchen, 'м2', '') : [[{colSpan: 6, rowSpan: 4, text: 'Штукатурные потолки: нет'}, {},{},{},{},{}],['', '','','','','',], ['', '','','','','',], ['', '','','','','',]];

            // stretch Ceiling
        let  stretchCeilingItemKitchen =  stretchCeilingKitchen ? getTwoArrays(`Натяжные потолки`, `Стоимость за метр в квадрате`, 600, ceilingAreaKitchen, 'м2', '') : [[{colSpan: 6, rowSpan: 2, text: 'Натяжные потолки: нет'}, {},{},{},{},{}],['', '','','','','',]];

            // gypsum eiling
        let  gypsumCeilingItemKitchen =  gypsumCeilingKitchen ? getFoureArrays(`Гипрочные потолки`, 'Монтаж одноуровневого потолочного металлокаркаса для последующего монтажа ГКЛ', 600, 'Монтаж ГКЛ, ГКЛП, ГКЛВ в 1 слой на потолок', 150, 'Заделка стыков на потолочных листах гипсокартона и отверстий от саморезов (подготовка к нанесению шпатлёвки)', 50, ceilingAreaKitchen, 'м2', '') : [[{colSpan: 6, rowSpan: 4, text: 'Гипрочные потолки: нет'}, {},{},{},{},{}],['', '','','','','',], ['', '','','','','',], ['', '','','','','',]];

        // Black works  
        let ceilingBlackWorksKitchen = blakCeilingWorksKitchen ? [
            [{text: `Черновые работы`, style: 'tableHeader', colSpan: 6, alignment: 'center', fillColor: '#DBE7F2'}, {}, {}, {}, {}, {}],
            plasterCeilingItemKitchen[0],
            plasterCeilingItemKitchen[1],
            plasterCeilingItemKitchen[2],
            plasterCeilingItemKitchen[3],
            stretchCeilingItemKitchen[0],
            stretchCeilingItemKitchen[1],
            gypsumCeilingItemKitchen[0],
            gypsumCeilingItemKitchen[1],
            gypsumCeilingItemKitchen[2],
            gypsumCeilingItemKitchen[3]
        ] : [[{colSpan: 6, rowSpan: 11, text: 'Черновые работы: нет'}, {},{},{},{},{}],['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',]];

        // White works 
            // for plaster Ceiling
        let forPlasterCeilingItemKitchen = forPlasterCeilingKitchen ? getThreeArrays(`При штукатурке`, 'Шпатлёвка потолка ', 350, 'Ошкуривание потолка', 110, ceilingAreaKitchen, 'м2', '') : [[{colSpan: 6, rowSpan: 3, text: 'При штукатурке: нет'}, {},{},{},{},{}],['', '','','','','',], ['', '','','','','',]];

            // for Gypsum Ceiling
        let  forGypsumCeilingItemKitchen =  forGypsumCeilingKitchen ? getFoureArrays(`При гипроке`, 'Шпатлёвка потолка под обои, стеклохолст, декоративные элементы в 2 слоя', 350, 'Поклейка стеклохолста на потолок (требуется при подготовке потолка под покраску)', 250, 'Ошкуривание потолка', 110, ceilingAreaKitchen, 'м2', '') : [[{colSpan: 6, rowSpan: 4, text: 'При гипроке: нет'}, {},{},{},{},{}],['', '','','','','',], ['', '','','','','',], ['', '','','','','',]];

    
            // White works  
        let ceilingWhitekWorksKitchen = whiteCeilingWorksKitchen ? [
            [{text: `Чистовое выравнивание`, style: 'tableHeader', colSpan: 6, alignment: 'center', fillColor: '#DBE7F2'}, {}, {}, {}, {}, {}],
            forPlasterCeilingItemKitchen[0],
            forPlasterCeilingItemKitchen[1],
            forPlasterCeilingItemKitchen[2],
            forGypsumCeilingItemKitchen[0],
            forGypsumCeilingItemKitchen[1],
            forGypsumCeilingItemKitchen[2],
            forGypsumCeilingItemKitchen[3]
        ] : [[{colSpan: 6, rowSpan: 8, text: 'Чистовое выравнивание: нет'}, {},{},{},{},{}],['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',]];

        //painting Ceiling Works 

        let  ceilingPaintingkWorksKitchen =  paintingCeilingWorksKitchen ? getTwoArrays(`Покраска`, `Покраска потолка в 2 слоя`, 300, ceilingAreaKitchen, 'м2', '#DBE7F2') : [[{colSpan: 6, rowSpan: 2, text: 'Натяжные потолки: нет'}, {},{},{},{},{}],['', '','','','','',]];

        let kitchenTotal = getTotal('кухня:', totalKitchen);

         // rooms

        let roomsNumber = numberRooms,
            allRoomsWalsArea = walsSquereRooms,
            allRoomsFloorArea = allFloorSquereRooms,
            allRoomsCeilingArea = ceilingSquereRooms;
    
        // rooms
            // floor

        let blackFloorWorksRooms = getBoolean(floorBlackLetRooms),
            whiteFloorWorksRooms = getBoolean(floorWhiteLetRooms),
            flooringFloorWorksRooms = getBoolean(flooringLetRooms),
            linoleumRooms = floorinfSelectedRooms === 'Линолиум' ? true : false,
            lamParketRooms = floorinfSelectedRooms === 'Ламинированый паркет' ? true : false,
            parketRooms =  floorinfSelectedRooms === 'Паркетная доска' ? true : false,
            floorTileRooms = floorinfSelectedRooms === 'Напольная плитка керамогранит' ? true : false;
            
        // Black works 
        let floorBlakWorksRooms = blackFloorWorksRooms ? getFiveArrays(`Черновые работы`,'Грунтовка пола (1 слой) «бетоконтактом»', 80, 'Засыпка керамзитом', 100, 'Настил плёнки гидроизоляционной', 50, 'Стяжка пола толщиной до 30 мм (ЦПС) с установкой маяков', 500, allRoomsFloorArea, 'м2',  '#DBE7F2') : [[{colSpan: 6, rowSpan: 5, text: 'Черновые работы: нет'}, {},{},{},{},{}],['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',]];
        // White works 
        let floorWhiteWorksRooms = whiteFloorWorksRooms ? getThreeArrays('Чистовое выравнивание', 'Нанесение пропиточного грунта (2 слоя) на существующее основание (ЦПС / сухая стяжка)', 70, 'Выравнивание пола финишным нивеллиром до 20 мм (наливной пол)', 260, allRoomsFloorArea, 'м2', '#DBE7F2'): [[{colSpan: 6, rowSpan: 3, text: 'Чистовое выравнивание: нет'}, {},{},{},{},{}],['', '','','','','',], ['', '','','','','',]];

        // flooring
            // linoleum
        let linoleumItemRooms = linoleumRooms ? getThreeArrays(`Линолиум`, 'Обеспыливание пола (перед настилом напольных покрытий)', 40, 'Настил линолеума', 250, allRoomsFloorArea, 'м2', '') : [[{colSpan: 6, rowSpan: 3, text: 'Линолиум: нет'}, {},{},{},{},{}],['', '','','','','',], ['', '','','','','',]];

            // lamparket
        let lamParketItemRooms = lamParketRooms ? getFoureArrays(`Ламинированый паркет`, 'Обеспыливание пола (перед настилом напольных покрытий)', 40, 'Настил подложки листовой, пробковой, хвойной', 50, 'Настил ламината бесшовного', 400, allRoomsFloorArea, 'м2', '') : [[{colSpan: 6, rowSpan: 4, text: 'Ламинированый паркет: нет'}, {},{},{},{},{}],['', '','','','','',], ['', '','','','','',], ['', '','','','','',]];

            // parket
        let  parketItemRooms =  parketRooms ? getThreeArrays(`Паркетная доска`, 'Обеспыливание пола (перед настилом напольных покрытий)', 40, 'Настил паркетной доски плавающим образом', 450, allRoomsFloorArea, 'м2', '') : [[{colSpan: 6, rowSpan: 3, text: 'Паркетная доска: нет'}, {},{},{},{},{}],['', '','','','','',], ['', '','','','','',]];

            // tile
        let  floorTileItemRooms =  floorTileRooms ? getThreeArrays(`Напольная плитка керамогранит`, 'Обеспыливание пола (перед настилом напольных покрытий)', 40, 'Укладка керамической плитки на пол/стены: размер 200х300, 300х300, 400х250, 400х400, 500х300, 500х500 мм', 1200, allRoomsFloorArea, 'м2', '') : [[{colSpan: 6, rowSpan: 3, text: 'Напольная плитка керамогранит: нет'}, {},{},{},{},{}],['', '','','','','',], ['', '','','','','',]];

        let floorFlooringWorksRooms = flooringFloorWorksRooms ? [
            [{text: `Напольное покрытие`, style: 'tableHeader', colSpan: 6, alignment: 'center', fillColor: '#DBE7F2'}, {}, {}, {}, {}, {}],
            linoleumItemKitchen[0],
            linoleumItemRooms[1],
            linoleumItemRooms[2],
            lamParketItemRooms[0],
            lamParketItemRooms[1],
            lamParketItemRooms[2],
            lamParketItemRooms[3],
            parketItemRooms[0],
            parketItemRooms[1],
            parketItemRooms[2],
            floorTileItemRooms[0],
            floorTileItemRooms[1],
            floorTileItemRooms[2]
        ] : [[{colSpan: 6, rowSpan: 14, text: 'Напольное покрытие: нет'}, {},{},{},{},{}],['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',]];

    // rooms
    // wals 
    
    let blackWalsWorksRooms = getBoolean(walsBlackLetRooms),
        plasterRooms =  walsBlackSelectedRooms === 'Штукатурные стены' ? true : false,
        gypsumPlasterboardRooms =  walsBlackSelectedRooms === 'Гипрочные стены' ? true : false,
        whiteWalsWorksRooms = getBoolean(walsWhiteLetRooms),
        forWallpaperRooms = walsWhiteSelectedRooms === 'Под обои' ? true : false,
        forPaintingRooms = walsWhiteSelectedRooms === 'Под покраску' ? true : false,
        finishWalsWorksRooms = getBoolean(walsFinishingletRooms),
        paintingRooms =  walsFinishingSelectedRooms === 'Покраска стен в 2 слоя' ? true : false,
        wallpaperingRooms = walsFinishingSelectedRooms === 'Поклейка обоев' ? true : false;

    // Black works 
        // plaster
    let plasterItemRooms = plasterRooms ? getFoureArrays(`Штукатурные стены`, 'Грунтовка стен (1 слой)', 40, 'Выравнивание стен гипсовой штукатурной смесью по маякам до 30 мм', 120, 'Монтаж маяков', 400, allRoomsWalsArea, 'м2', '') : [[{colSpan: 6, rowSpan: 4, text: 'Штукатурные стены: нет'}, {},{},{},{},{}],['', '','','','','',], ['', '','','','','',], ['', '','','','','',]];

        // gypsum PlasterboardKitchen
    let  gypsumPlasterboardItemRooms =  gypsumPlasterboardRooms ? getThreeArrays(`Гипрочные стены`, 'Устройство ГКЛ фальш стены в 1 слой (возведение одностороннего металлокаркаса с обшивкой ГКЛ в 1 слой с одной стороны)', 550, 'Заделка стыков на потолочных листах гипсокартона и отверстий от саморезов (подготовка к нанесению шпатлёвки)', 50, allRoomsWalsArea, 'м2', '') : [[{colSpan: 6, rowSpan: 3, text: 'Гипрочные стены: нет'}, {},{},{},{},{}],['', '','','','','',], ['', '','','','','',]];

    // Black works  
    let walsBlackWorksRooms = blackWalsWorksRooms ? [
        [{text: `Черновые работы`, style: 'tableHeader', colSpan: 6, alignment: 'center', fillColor: '#DBE7F2'}, {}, {}, {}, {}, {}],
        plasterItemRooms[0],
        plasterItemRooms[1],
        plasterItemRooms[2],
        plasterItemRooms[3],
        gypsumPlasterboardItemRooms[0],
        gypsumPlasterboardItemRooms[1],
        gypsumPlasterboardItemRooms[2],
    ] : [[{colSpan: 6, rowSpan: 8, text: 'Черновые работы: нет'}, {},{},{},{},{}],['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',]];

    // White works 
        // for Wallpaper
    let forWallpaperItemRooms = forWallpaperRooms ?  getThreeArrays(`Под обои`, 'Шпатлёвка стен под обои, стеклохолст, декоративные элементы в 2 слоя', 280, 'Ошкуривание стен', 100, allRoomsWalsArea, 'м2', '') : [[{colSpan: 6, rowSpan: 3, text: 'Под обои: нет'}, {},{},{},{},{}],['', '','','','','',], ['', '','','','','',]];

        //  for Painting 
    let  forPaintingItemRooms =  forPaintingRooms  ? getFiveArrays(`Под покраску`,'Шпатлёвка стен под обои, стеклохолст, декоративные элементы в 2 слоя', 280, 'Шпатлёвка стен под покраску в 2 слоя (финишная шпатлёвка SheetRock)', 320, 'Поклейка стеклохолста на стену (требуется при подготовке стен под покраску)', 200, 'Ошкуривание стен', 100, allRoomsWalsArea, 'м2',  ' ') : [[{colSpan: 6, rowSpan: 5, text: 'Под покраску: нет'}, {},{},{},{},{}],['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',]];

    // White works  
    let walsWhiteWorksRooms = whiteWalsWorksRooms ? [
        [{text: `Чистовое выравнивание`, style: 'tableHeader', colSpan: 6, alignment: 'center', fillColor: '#DBE7F2'}, {}, {}, {}, {}, {}],
        forWallpaperItemRooms[0],
        forWallpaperItemRooms[1],
        forWallpaperItemRooms[2],
        forPaintingItemRooms[0],
        forPaintingItemRooms[1],
        forPaintingItemRooms[2],
        forPaintingItemRooms[3],
        forPaintingItemRooms[4],
    ] : [[{colSpan: 6, rowSpan: 9, text: 'Чистовое выравнивание: нет'}, {},{},{},{},{}],['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',]];

    // Finishing works 
        // for Wallpaper
    let paintingItemRooms = paintingRooms ?  getTwoArrays(`Покраска`, `Покраска стен в 2 слоя`, 260, allRoomsWalsArea, 'м2', '') : [[{colSpan: 6, rowSpan: 2, text: 'Покраска: нет'}, {},{},{},{},{}],['', '','','','','',]];

        //  wallpapering
    let  wallpaperingItemRooms =  wallpaperingRooms  ? getTwoArrays(`Поклейка обоев`, `Оклейка стен бумажными, виниловыми, флизелиновыми обоями с подгонкой рисунка (стоимостью до 1500р / рулон — 1ая категория стоимости)`, 360, allRoomsWalsArea, 'м2', '') : [[{colSpan: 6, rowSpan: 2, text: 'Поклейка обоев: нет'}, {},{},{},{},{}],['', '','','','','',]];

    // Finishing works  
    let walsfinisWorksRooms = finishWalsWorksRooms ? [
        [{text: `Отделка`, style: 'tableHeader', colSpan: 6, alignment: 'center', fillColor: '#DBE7F2'}, {}, {}, {}, {}, {}],
        paintingItemRooms[0],
        paintingItemRooms[1],
        wallpaperingItemRooms[0],
        wallpaperingItemRooms[1],
    ] : [[{colSpan: 6, rowSpan: 5, text: 'Отделка: нет'}, {},{},{},{},{}],['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',]];

    // Rooms
    // ceiling

    let blakCeilingWorksRooms = getBoolean(ceilingBlackLetRooms),
        plasterCeilingRooms = ceilingBlackSelectedRooms === 'Штукатурные потолки' ? true : false,
        stretchCeilingRooms = ceilingBlackSelectedRooms === 'Натяжные потолки' ? true : false,
        gypsumCeilingRooms = ceilingBlackSelectedRooms === 'Гипрочные потолки' ? true : false,
        whiteCeilingWorksRooms = getBoolean(ceilingWhiteLetRooms),
        forPlasterCeilingRooms = ceilingWhiteSelectedRooms === 'При штукатурке' ? true : false,
        forGypsumCeilingRooms = ceilingWhiteSelectedRooms === 'При гипроке' ? true : false,
        paintingCeilingWorksRooms = getBoolean(ceilingPaintingLetRooms);

        // Black works 
            // plaster Ceiling
        let plasterCeilingItemRooms = plasterCeilingRooms ? getFoureArrays(`Штукатурные потолки`, 'Грунтовка стен (1 слой)', 50, 'Выравнивание стен гипсовой штукатурной смесью по маякам до 30 мм', 550, 'Монтаж маяков', 130, allRoomsCeilingArea, 'м2', '') : [[{colSpan: 6, rowSpan: 4, text: 'Штукатурные потолки: нет'}, {},{},{},{},{}],['', '','','','','',], ['', '','','','','',], ['', '','','','','',]];

            // stretch Ceiling
        let  stretchCeilingItemRooms =  stretchCeilingRooms ? getTwoArrays(`Натяжные потолки`, `Стоимость за метр в квадрате`, 600, allRoomsCeilingArea, 'м2', '') : [[{colSpan: 6, rowSpan: 2, text: 'Натяжные потолки: нет'}, {},{},{},{},{}],['', '','','','','',]];

            // gypsum eiling
        let  gypsumCeilingItemRooms =  gypsumCeilingRooms ? getFoureArrays(`Гипрочные потолки`, 'Монтаж одноуровневого потолочного металлокаркаса для последующего монтажа ГКЛ', 600, 'Монтаж ГКЛ, ГКЛП, ГКЛВ в 1 слой на потолок', 150, 'Заделка стыков на потолочных листах гипсокартона и отверстий от саморезов (подготовка к нанесению шпатлёвки)', 50, allRoomsCeilingArea, 'м2', '') : [[{colSpan: 6, rowSpan: 4, text: 'Гипрочные потолки: нет'}, {},{},{},{},{}],['', '','','','','',], ['', '','','','','',], ['', '','','','','',]];

        // Black works  
        let ceilingBlackWorksRooms = blakCeilingWorksRooms ? [
            [{text: `Черновые работы`, style: 'tableHeader', colSpan: 6, alignment: 'center', fillColor: '#DBE7F2'}, {}, {}, {}, {}, {}],
            plasterCeilingItemRooms[0],
            plasterCeilingItemRooms[1],
            plasterCeilingItemRooms[2],
            plasterCeilingItemRooms[3],
            stretchCeilingItemRooms[0],
            stretchCeilingItemRooms[1],
            gypsumCeilingItemRooms[0],
            gypsumCeilingItemRooms[1],
            gypsumCeilingItemRooms[2],
            gypsumCeilingItemRooms[3]
        ] : [[{colSpan: 6, rowSpan: 11, text: 'Черновые работы: нет'}, {},{},{},{},{}],['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',]];

        // White works 
            // for plaster Ceiling
        let forPlasterCeilingItemRooms = forPlasterCeilingRooms ? getThreeArrays(`При штукатурке`, 'Шпатлёвка потолка ', 350, 'Ошкуривание потолка', 110, allRoomsCeilingArea, 'м2', '') : [[{colSpan: 6, rowSpan: 3, text: 'При штукатурке: нет'}, {},{},{},{},{}],['', '','','','','',], ['', '','','','','',]];

            // for Gypsum Ceiling
        let  forGypsumCeilingItemRooms =  forGypsumCeilingRooms ? getFoureArrays(`При гипроке`, 'Шпатлёвка потолка под обои, стеклохолст, декоративные элементы в 2 слоя', 350, 'Поклейка стеклохолста на потолок (требуется при подготовке потолка под покраску)', 250, 'Ошкуривание потолка', 110, allRoomsCeilingArea, 'м2', '') : [[{colSpan: 6, rowSpan: 4, text: 'При гипроке: нет'}, {},{},{},{},{}],['', '','','','','',], ['', '','','','','',], ['', '','','','','',]];

    
            // White works  
        let ceilingWhitekWorksRooms = whiteCeilingWorksRooms ? [
            [{text: `Чистовое выравнивание`, style: 'tableHeader', colSpan: 6, alignment: 'center', fillColor: '#DBE7F2'}, {}, {}, {}, {}, {}],
            forPlasterCeilingItemRooms[0],
            forPlasterCeilingItemRooms[1],
            forPlasterCeilingItemRooms[2],
            forGypsumCeilingItemRooms[0],
            forGypsumCeilingItemRooms[1],
            forGypsumCeilingItemRooms[2],
            forGypsumCeilingItemRooms[3]
        ] : [[{colSpan: 6, rowSpan: 8, text: 'Чистовое выравнивание: нет'}, {},{},{},{},{}],['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',]];

        //painting Ceiling Works 

        let  ceilingPaintingkWorksRooms =  paintingCeilingWorksRooms ? getTwoArrays(`Покраска`, `Покраска потолка в 2 слоя`, 300, allRoomsCeilingArea, 'м2', '#DBE7F2') : [[{colSpan: 6, rowSpan: 2, text: 'Натяжные потолки: нет'}, {},{},{},{},{}],['', '','','','','',]];

        let roomsTotal = getTotal('комнаты:', totalRooms);

        // Hall
        // floor

    let florAreaHall = floorSquereHall,
        blackFloorWorksHall = getBoolean(floorWhiteLetHall),
        whiteFloorWorksHall = getBoolean(floorBlackLetHall),
        flooringFloorWorksHall = getBoolean(flooringLetHall),
        linoleumHall = floorinfSelectedHall === 'Линолиум' ? true : false,
        lamParketHall = floorinfSelectedHall === 'Ламинированый паркет' ? true : false,
        parketHall = floorinfSelectedHall === 'Паркетная доска' ? true : false,
        floorTileHall = floorinfSelectedHall === 'Напольная плитка керамогранит' ? true : false;

    // Black works 
    let floorBlakWorksHall = blackFloorWorksHall ? getFiveArrays(`Черновые работы`,'Грунтовка пола (1 слой) «бетоконтактом»', 80, 'Засыпка керамзитом', 100, 'Настил плёнки гидроизоляционной', 50, 'Стяжка пола толщиной до 30 мм (ЦПС) с установкой маяков', 500, florAreaHall, 'м2',  '#DBE7F2') : [[{colSpan: 6, rowSpan: 5, text: 'Черновые работы: нет'}, {},{},{},{},{}],['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',]];
    // White works 
    let floorWhiteWorksHall = whiteFloorWorksHall ? getThreeArrays('Чистовое выравнивание', 'Нанесение пропиточного грунта (2 слоя) на существующее основание (ЦПС / сухая стяжка)', 70, 'Выравнивание пола финишным нивеллиром до 20 мм (наливной пол)', 260, florAreaHall, 'м2', '#DBE7F2'): [[{colSpan: 6, rowSpan: 3, text: 'Чистовое выравнивание: нет'}, {},{},{},{},{}],['', '','','','','',], ['', '','','','','',]];

    // flooring
        // linoleum
    let linoleumItemHall = linoleumHall ? getThreeArrays(`Линолиум`, 'Обеспыливание пола (перед настилом напольных покрытий)', 40, 'Настил линолеума', 250, florAreaHall, 'м2', '') : [[{colSpan: 6, rowSpan: 3, text: 'Линолиум: нет'}, {},{},{},{},{}],['', '','','','','',], ['', '','','','','',]];

        // lamparket
    let lamParketItemHall = lamParketHall ? getFoureArrays(`Ламинированый паркет`, 'Обеспыливание пола (перед настилом напольных покрытий)', 40, 'Настил подложки листовой, пробковой, хвойной', 50, 'Настил ламината бесшовного', 400, florAreaHall, 'м2', '') : [[{colSpan: 6, rowSpan: 4, text: 'Ламинированый паркет: нет'}, {},{},{},{},{}],['', '','','','','',], ['', '','','','','',], ['', '','','','','',]];

        // parket
    let  parketItemHall =  parketHall ? getThreeArrays(`Паркетная доска`, 'Обеспыливание пола (перед настилом напольных покрытий)', 40, 'Настил паркетной доски плавающим образом', 450, florAreaHall, 'м2', '#DBE7F2') : [[{colSpan: 6, rowSpan: 3, text: 'Паркетная доска: нет'}, {},{},{},{},{}],['', '','','','','',], ['', '','','','','',]];

        // tile
    let  floorTileItemHall =  floorTileHall ? getThreeArrays(`Напольная плитка керамогранит`, 'Обеспыливание пола (перед настилом напольных покрытий)', 40, 'Укладка керамической плитки на пол/стены: размер 200х300, 300х300, 400х250, 400х400, 500х300, 500х500 мм', 1200, florAreaHall, 'м2', '#DBE7F2') : [[{colSpan: 6, rowSpan: 3, text: 'Напольная плитка керамогранит: нет'}, {},{},{},{},{}],['', '','','','','',], ['', '','','','','',]];

    let floorFlooringWorksHall = flooringFloorWorksHall ? [
        [{text: `Напольное покрытие`, style: 'tableHeader', colSpan: 6, alignment: 'center', fillColor: '#DBE7F2'}, {}, {}, {}, {}, {}],
        linoleumItemHall[0],
        linoleumItemHall[1],
        linoleumItemHall[2],
        lamParketItemHall[0],
        lamParketItemHall[1],
        lamParketItemHall[2],
        lamParketItemHall[3],
        parketItemHall[0],
        parketItemHall[1],
        parketItemHall[2],
        floorTileItemHall[0],
        floorTileItemHall[1],
        floorTileItemHall[2]
    ] : [[{colSpan: 6, rowSpan: 14, text: 'Напольное покрытие: нет'}, {},{},{},{},{}],['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',]];

    // Hall
    // wals
    let walsAreHall = walsSquereHall,
        blackWalsWorksHall = getBoolean(walsBlackLetHall),
        plasterHall =  walsBlackSelectedHall === 'Штукатурные стены' ? true : false,
        gypsumPlasterboardHall =  walsBlackSelectedHall === 'Гипрочные стены' ? true : false,
        whiteWalsWorksHall = getBoolean(walsWhiteLetHall),
        forWallpaperHall = walsWhiteSelectedHall === 'Под обои' ? true : false,
        forPaintingHall = walsWhiteSelectedHall === 'Под покраску' ? true : false,
        finishWalsWorksHall = getBoolean(walsFinishingletHall),
        paintingHall = walsFinishingSelectedHall === 'Покраска стен в 2 слоя' ? true : false,
        wallpaperingHall = walsFinishingSelectedHall === 'Поклейка обоев' ? true : false;
    
    // Black works 
        // plaster
    let plasterItemHall = plasterHall ? getFoureArrays(`Штукатурные стены`, 'Грунтовка стен (1 слой)', 40, 'Выравнивание стен гипсовой штукатурной смесью по маякам до 30 мм', 120, 'Монтаж маяков', 400, walsAreHall, 'м2', '') : [[{colSpan: 6, rowSpan: 4, text: 'Штукатурные стены: нет'}, {},{},{},{},{}],['', '','','','','',], ['', '','','','','',], ['', '','','','','',]];

        // gypsum PlasterboardKitchen
    let  gypsumPlasterboardItemHall =  gypsumPlasterboardHall ? getThreeArrays(`Гипрочные стены`, 'Устройство ГКЛ фальш стены в 1 слой (возведение одностороннего металлокаркаса с обшивкой ГКЛ в 1 слой с одной стороны)', 550, 'Заделка стыков на потолочных листах гипсокартона и отверстий от саморезов (подготовка к нанесению шпатлёвки)', 50, walsAreHall, 'м2', '') : [[{colSpan: 6, rowSpan: 3, text: 'Гипрочные стены: нет'}, {},{},{},{},{}],['', '','','','','',], ['', '','','','','',]];

    // Black works  
    let walsBlackWorksHall = blackWalsWorksHall ? [
        [{text: `Черновые работы`, style: 'tableHeader', colSpan: 6, alignment: 'center', fillColor: '#DBE7F2'}, {}, {}, {}, {}, {}],
        plasterItemHall[0],
        plasterItemHall[1],
        plasterItemHall[2],
        plasterItemHall[3],
        gypsumPlasterboardItemHall[0],
        gypsumPlasterboardItemHall[1],
        gypsumPlasterboardItemHall[2],
    ] : [[{colSpan: 6, rowSpan: 8, text: 'Черновые работы: нет'}, {},{},{},{},{}],['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',]];

    // White works 
        // for Wallpaper
    let forWallpaperItemHall = forWallpaperHall ?  getThreeArrays(`Под обои`, 'Шпатлёвка стен под обои, стеклохолст, декоративные элементы в 2 слоя', 280, 'Ошкуривание стен', 100, walsAreHall, 'м2', '') : [[{colSpan: 6, rowSpan: 3, text: 'Под обои: нет'}, {},{},{},{},{}],['', '','','','','',], ['', '','','','','',]];
 
        //  for Painting 
    let  forPaintingItemHall =  forPaintingHall  ? getFiveArrays(`Под покраску`,'Шпатлёвка стен под обои, стеклохолст, декоративные элементы в 2 слоя', 280, 'Шпатлёвка стен под покраску в 2 слоя (финишная шпатлёвка SheetRock)', 320, 'Поклейка стеклохолста на стену (требуется при подготовке стен под покраску)', 200, 'Ошкуривание стен', 100, walsAreHall, 'м2', ' ') : [[{colSpan: 6, rowSpan: 5, text: 'Под покраску: нет'}, {},{},{},{},{}],['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',]];

    // White works  
    let walsWhiteWorksHall = whiteWalsWorksHall ? [
        [{text: `Чистовое выравнивание`, style: 'tableHeader', colSpan: 6, alignment: 'center', fillColor: '#DBE7F2'}, {}, {}, {}, {}, {}],
        forWallpaperItemHall[0],
        forWallpaperItemHall[1],
        forWallpaperItemHall[2],
        forPaintingItemHall[0],
        forPaintingItemHall[1],
        forPaintingItemHall[2],
        forPaintingItemHall[3],
        forPaintingItemHall[4],
    ] : [[{colSpan: 6, rowSpan: 9, text: 'Чистовое выравнивание: нет'}, {},{},{},{},{}],['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',]];

    // Finishing works 
        // for Wallpaper
    let paintingItemHall = paintingHall ?  getTwoArrays(`Покраска`, `Покраска стен в 2 слоя`, 260, walsAreHall, 'м2', '') : [[{colSpan: 6, rowSpan: 2, text: 'Покраска: нет'}, {},{},{},{},{}],['', '','','','','',]];
 
        //  wallpapering
    let  wallpaperingItemHall =  wallpaperingHall  ? getTwoArrays(`Поклейка обоев`, `Оклейка стен бумажными, виниловыми, флизелиновыми обоями с подгонкой рисунка (стоимостью до 1500р / рулон — 1ая категория стоимости)`, 360, walsAreHall, 'м2', '') : [[{colSpan: 6, rowSpan: 2, text: 'Поклейка обоев: нет'}, {},{},{},{},{}],['', '','','','','',]];

    // Finishing works  
    let walsfinisWorksHall = finishWalsWorksHall ? [
        [{text: `Отделка`, style: 'tableHeader', colSpan: 6, alignment: 'center', fillColor: '#DBE7F2'}, {}, {}, {}, {}, {}],
        paintingItemHall[0],
        paintingItemHall[1],
        wallpaperingItemHall[0],
        wallpaperingItemHall[1],
    ] : [[{colSpan: 6, rowSpan: 5, text: 'Отделка: нет'}, {},{},{},{},{}],['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',]];

    // Hall
    // ceiling

    let ceilingAreaHall = ceilingSquereHall,
        blackCeilingWorksHall = getBoolean(ceilingBlackLetHall),
        plasterCeilingHall = ceilingBlackSelectedHall === 'Штукатурные потолки' ? true : false,
        stretchCeilingHall = ceilingBlackSelectedHall === 'Натяжные потолки' ? true : false,
        gypsumCeilingHall = ceilingBlackSelectedHall === 'Гипрочные потолки' ? true : false,
        whiteCeilingWorksHall = getBoolean(ceilingWhiteLetHall),
        forPlasterCeilingHall = ceilingWhiteSelectedHall === 'При штукатурке' ? true : false,
        forGypsumCeilingHall = ceilingWhiteSelectedHall === 'При гипроке' ? true : false,
        paintingCeilingWorksHall = getBoolean(ceilingPaintingLetHall);
    
    // Black works 
            // plaster Ceiling
        let plasterCeilingItemHall = plasterCeilingHall ? getFoureArrays(`Штукатурные потолки`, 'Грунтовка стен (1 слой)', 50, 'Выравнивание стен гипсовой штукатурной смесью по маякам до 30 мм', 550, 'Монтаж маяков', 130, ceilingAreaHall, 'м2', '') : [[{colSpan: 6, rowSpan: 4, text: 'Штукатурные потолки: нет'}, {},{},{},{},{}],['', '','','','','',], ['', '','','','','',], ['', '','','','','',]];

            // stretch Ceiling
        let  stretchCeilingItemHall =  stretchCeilingHall ? getTwoArrays(`Натяжные потолки`, `Стоимость за метр в квадрате`, 600, ceilingAreaHall, 'м2', '') : [[{colSpan: 6, rowSpan: 2, text: 'Натяжные потолки: нет'}, {},{},{},{},{}],['', '','','','','',]];

            // gypsum eiling
        let  gypsumCeilingItemHall =  gypsumCeilingHall ? getFoureArrays(`Гипрочные потолки`, 'Монтаж одноуровневого потолочного металлокаркаса для последующего монтажа ГКЛ', 600, 'Монтаж ГКЛ, ГКЛП, ГКЛВ в 1 слой на потолок', 150, 'Заделка стыков на потолочных листах гипсокартона и отверстий от саморезов (подготовка к нанесению шпатлёвки)', 50, ceilingAreaHall, 'м2', '') : [[{colSpan: 6, rowSpan: 4, text: 'Гипрочные потолки: нет'}, {},{},{},{},{}],['', '','','','','',], ['', '','','','','',], ['', '','','','','',]];

        // Black works  
        let ceilingBlackWorksHall = blackCeilingWorksHall ? [
            [{text: `Черновые работы`, style: 'tableHeader', colSpan: 6, alignment: 'center', fillColor: '#DBE7F2'}, {}, {}, {}, {}, {}],
            plasterCeilingItemHall[0],
            plasterCeilingItemHall[1],
            plasterCeilingItemHall[2],
            plasterCeilingItemHall[3],
            stretchCeilingItemHall[0],
            stretchCeilingItemHall[1],
            gypsumCeilingItemHall[0],
            gypsumCeilingItemHall[1],
            gypsumCeilingItemHall[2],
            gypsumCeilingItemHall[3]
        ] : [[{colSpan: 6, rowSpan: 11, text: 'Черновые работы: нет'}, {},{},{},{},{}],['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',]];

        // White works 
            // for plaster Ceiling
        let forPlasterCeilingItemHall = forPlasterCeilingHall ? getThreeArrays(`При штукатурке`, 'Шпатлёвка потолка ', 350, 'Ошкуривание потолка', 110, ceilingAreaHall, 'м2', '') : [[{colSpan: 6, rowSpan: 3, text: 'При штукатурке: нет'}, {},{},{},{},{}],['', '','','','','',], ['', '','','','','',]];

            // for Gypsum Ceiling
        let  forGypsumCeilingItemHall =  forGypsumCeilingHall ? getFoureArrays(`При гипроке`, 'Шпатлёвка потолка под обои, стеклохолст, декоративные элементы в 2 слоя', 350, 'Поклейка стеклохолста на потолок (требуется при подготовке потолка под покраску)', 250, 'Ошкуривание потолка', 110, ceilingAreaHall, 'м2', '') : [[{colSpan: 6, rowSpan: 4, text: 'При гипроке: нет'}, {},{},{},{},{}],['', '','','','','',], ['', '','','','','',], ['', '','','','','',]];

    
            // White works  
        let ceilingWhitekWorksHall = whiteCeilingWorksHall ? [
            [{text: `Чистовое выравнивание`, style: 'tableHeader', colSpan: 6, alignment: 'center', fillColor: '#DBE7F2'}, {}, {}, {}, {}, {}],
            forPlasterCeilingItemHall[0],
            forPlasterCeilingItemHall[1],
            forPlasterCeilingItemHall[2],
            forGypsumCeilingItemHall[0],
            forGypsumCeilingItemHall[1],
            forGypsumCeilingItemHall[2],
            forGypsumCeilingItemHall[3]
        ] : [[{colSpan: 6, rowSpan: 8, text: 'Чистовое выравнивание: нет'}, {},{},{},{},{}],['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',]];

        //painting Ceiling Works 

        let  ceilingPaintingkWorksHall =  paintingCeilingWorksHall ? getTwoArrays(`Покраска`, `Покраска потолка в 2 слоя`, 300, ceilingAreaHall, 'м2', '#DBE7F2') : [[{colSpan: 6, rowSpan: 2, text: 'Натяжные потолки: нет'}, {},{},{},{},{}],['', '','','','','',]];

        let hallTotal = getTotal('кухня:', totalHall);

    // Bathroom 
    // floor

    let floorAreaBath = floorSquereBath,
       blackFloorWorksBath = getBoolean(floorBlackLetBath),
       whiteFloorWorksBath = getBoolean(floorWhiteLetBath),
       flooringFloorWorksBath = getBoolean(flooringLetBath);

    // Black works 
    let floorBlakWorksBath =  blackFloorWorksBath ? getFiveArrays(`Черновые работы`,'Грунтовка пола (1 слой) «бетоконтактом»', 80, 'Засыпка керамзитом', 100, 'Настил плёнки гидроизоляционной', 50, 'Стяжка пола толщиной до 30 мм (ЦПС) с установкой маяков', 500, floorAreaBath, 'м2', '#DBE7F2') : [[{colSpan: 6, rowSpan: 5, text: 'Черновые работы: нет'}, {},{},{},{},{}],['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',]];

    // White works 
    let floorWhiteWorksBath =  whiteFloorWorksBath ? getFoureArrays(`Чистовое выравнивание`, 'Нанесение пропиточного грунта (2 слоя) на существующее основание (ЦПС / сухая стяжка). Наносится перед использованием технологии «наливного пола»', 70, 'Выравнивание пола финишным нивеллиром до 20 мм (наливной пол', 260, 'Устройство гидроизоляции в 2 слоя (мастика) с 20 мм нахлёстом на стены', 200, floorAreaBath, 'м2', '#DBE7F2') : [[{colSpan: 6, rowSpan: 4, text: 'Чистовое выравнивание: нет'}, {},{},{},{},{}],['', '','','','','',], ['', '','','','','',], ['', '','','','','',]];
    
    // flooring
    let floorFlooringWorksBath = flooringFloorWorksBath ? getThreeArrays(`Напольное покрытие`, 'Обеспыливание пола (перед настилом напольных покрытий)', 40, 'Укладка керамической плитки на пол/стены: размер 200х300, 300х300, 400х250, 400х400, 500х300, 500х500 мм', 1200, floorAreaBath, 'м2', '#DBE7F2') : [[{colSpan: 6, rowSpan: 3, text: 'Напольное покрытие: нет'}, {},{},{},{},{}],['', '','','','','',], ['', '','','','','',]];
    
    //Bathroom
    // walls
    let wallsAreaBath = wallsSquereBath,
        blackWalsWorksBath = getBoolean(wallsBlackLetBath),
        finishWalsWorksBath = getBoolean(wallsFinishingletBath);


    // Black works 
    let wallsBlackWorksBath =  blackWalsWorksBath ? getFoureArrays(`Выравнивание (штукатурные стены)`, 'Грунтовка стен (1 слой)', 40, 'Выравнивание стен гипсовой штукатурной смесью по маякам до 30 мм', 120, 'Монтаж маяков', 400, wallsAreaBath, 'м2', '#DBE7F2') : [[{colSpan: 6, rowSpan: 4, text: 'Выравнивание (штукатурные стены): нет'}, {},{},{},{},{}],['', '','','','','',], ['', '','','','','',], ['', '','','','','',]];

    // finishing
    let wallsFinishingWorksBath = finishWalsWorksBath ? getThreeArrays(`Отделка стен (укладка кафельной плитки)`, 'Грунтовка стен (1 слой)', 40, 'Укладка керамической плитки на пол/стены: размер 200х300, 300х300, 400х250, 400х400, 500х300, 500х500 мм', 1200, wallsAreaBath, 'м2', '#DBE7F2') : [[{colSpan: 6, rowSpan: 3, text: 'Отделка стен (укладка кафельной плитки): нет'}, {},{},{},{},{}],['', '','','','','',], ['', '','','','','',]];

    // Bathroom
    // ceiling

    let ceilingAreaBath = ceilingSquereBath,
        blackCeilingWorksBath = getBoolean(cealingLetBath),
        plasterCeilingBath = ceilingSelectedBath === 'Штукатурные потолки' ? true : false,
        stretchCeilingBath = ceilingSelectedBath === 'Натяжные потолки' ? true : false,
        slattedCeilingBath = ceilingSelectedBath === 'Реечные потолки' ? true : false;

    // Cealing works 
        // plaster Ceiling
    let plasterCeilingItemBath = plasterCeilingBath ? getSevenArrays('Штукатурные потолки', 'Грунтовка потолка (1 слой)', 50,  'Выравнивание потолка гипсовой штукатурной смесью по маякам до 30 мм', 550, 'Монтаж маяков', 130, 'Шпатлёвка потолка под покраску', 350, 'Ошкуривание потолка', 110, 'Покраска потолка в 2 слоя', 300, ceilingAreaBath, 'м2', '') : [[{colSpan: 6, rowSpan: 7, text: 'Штукатурные потолки: нет'}, {},{},{},{},{}],['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',]];


        // stretch Ceiling
    let  stretchCeilingItemBath =  stretchCeilingBath ? getTwoArrays(`Натяжные потолки`, `Стоимость за метр в квадрате`, 600, ceilingAreaBath, 'м2', '') : [[{colSpan: 6, rowSpan: 2, text: 'Натяжные потолки: нет'}, {},{},{},{},{}],['', '','','','','',]];

        // slatted eiling
    let  slattedCeilingItemBath =  slattedCeilingBath ? getTwoArrays(`Реечные потолки`, `Стоимость за метр в квадрате`, 850, ceilingAreaBath, 'м2', '') : [[{colSpan: 6, rowSpan: 2, text: 'Реечные потолки: нет'}, {},{},{},{},{}],['', '','','','','',]];

    // Cealing works  
    let ceilingWorksBath = blackCeilingWorksBath ? [
        [{text: `Вид потолка`, style: 'tableHeader', colSpan: 6, alignment: 'center', fillColor: '#DBE7F2'}, {}, {}, {}, {}, {}],
            plasterCeilingItemBath[0],
            plasterCeilingItemBath[1],
            plasterCeilingItemBath[2],
            plasterCeilingItemBath[3],
            plasterCeilingItemBath[4],
            plasterCeilingItemBath[5],
            plasterCeilingItemBath[6],
            stretchCeilingItemBath[0],
            stretchCeilingItemBath[1],
            slattedCeilingItemBath[0],
            slattedCeilingItemBath[1],
        ] : [[{colSpan: 6, rowSpan: 12, text: 'Потолок: нет'}, {},{},{},{},{}],['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',]];

    let bathTotal = getTotal('Ванная:', totalBath);

     // electrica
    let panelElectica = getBoolean(electricPanel),
        socketsAndSockets = getBoolean(switchAndSocket),
        light = getBoolean(lightnessLet),
        chandlierNumber = numberOfChandlier;

    let panelElecticaWorks = panelElectica ? [
            [{text: `Монтаж электрощита`, style: 'tableHeader', colSpan: 6, alignment: 'center', fillColor: '#DBE7F2'}, {}, {}, {}, {}, {}],
            ['1', 'Монтаж электросчетчика', `шт`, ` 1`, `4500`, ` 4500`],
            ['2', 'Установка электрического щита', `шт`, ` 1`, `2200`, ` 2200`],
            ['3', 'Автоматы (уточняется по факту)', `комплект`, ` 1`,`5000`, ` 5000`],
        ] : [[{colSpan: 6, rowSpan: 4, text: 'Монтаж электрощита: нет'}, {},{},{},{},{}],['', '','','','','',], ['', '','','','','',], ['', '','','','','',]];

    let socketsAndSocketsWorks = socketsAndSockets ? [
        [{text: `Розетки и выключатели `, style: 'tableHeader', colSpan: 6, alignment: 'center', fillColor: '#DBE7F2'}, {}, {}, {}, {}, {}],
        ['1', 'Штробление под провод (пеноблок, ПГП - пазогребневая плита, гипс)', `п.м.`, `${switchAndSocketNumber*4}`, `800`, `${(switchAndSocketNumber*4)*800}`],
        ['2', 'Заделка штроб', `п.м.`, `${switchAndSocketNumber*4}`, `400`, `${(switchAndSocketNumber*4)*400}`],
        ['3', 'Прокладка провода в гофре', `п.м.`, `${switchAndSocketNumber*4}`,`600`, `${(switchAndSocketNumber*4)*600}`],
        ['4', 'Устройство подрозетника (ГКЛ, ПГП)', `шт`, `${switchAndSocketNumber}`,`170`, `${switchAndSocketNumber*170}`],
        ['5', 'Монтаж розеток и выключателей (1-ых)', `шт`, `${switchAndSocketNumber}`,`330`, `${switchAndSocketNumber*330}`],
    ] : [[{colSpan: 6, rowSpan: 6, text: 'Розетки и выключатели: нет'}, {},{},{},{},{}],['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',]];

    let lightnessWorks = light ? [
        [{text: `Освещение`, style: 'tableHeader', colSpan: 6, alignment: 'center', fillColor: '#DBE7F2'}, {}, {}, {}, {}, {}],
        ['1', 'Штробление под провод (пеноблок, ПГП - пазогребневая плита, гипс)', `п.м.`, `${chandlierNumber*5}`, `1000`, `${(chandlierNumber*5)*1000}`],
        ['2', 'Заделка штроб', `п.м.`, `${chandlierNumber*5}`, `500`, `${(chandlierNumber*5)*500}`],
        ['3', 'Прокладка провода в гофре', `п.м.`, `${chandlierNumber*5}`,`750`, `${(chandlierNumber*5)*750}`],
        ['4', 'Монтаж люстры', `шт`, `${chandlierNumber}`,`600`, `${chandlierNumber*600}`],
    ] : [[{colSpan: 6, rowSpan: 5, text: 'Освещение: нет'}, {},{},{},{},{}],['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',]];

    let electricTotal = getTotal('Электромонтажные работы:', totalElectric);

    // plumbing

    let tubingBool = getBoolean(tubingLet), 
        tubingPlusBool = getBoolean(tubingPlusLet),
        bathtubBool = getBoolean(bathtubLet), 
        showerCabinBool = getBoolean(showerCabinLet), 
        palletBool = getBoolean(palletLet), 
        showerHeadBool = getBoolean(showerHeadLet), 
        dishwasherBool = getBoolean(dishwasherLet), 
        sinkBool = getBoolean(sinkLet),  
        hygienicShowerBool = getBoolean(hygienicShowerLet), 
        tapBool = getBoolean(tapLet), 
        toiletBool = getBoolean(toiletLet), 
        dryerBool = getBoolean(dryerLet), 
        washerBool = getBoolean(washerLet);

        let numbers = bathtubNumLet + showerCabinNumLet + palletNumLet + showerHeadNumLet + dishwasherNumberLet + sinkNumberLet + hygienicShowerNumberLet + tapNumberLet + toiletNumberLet + dryerNumberLet + washerNumberLet;

    let tubingBoolWorks = tubingBool ? [
        [{text: `Прокладка труб`, style: 'tableHeader', colSpan: 6, alignment: 'center', fillColor: '#DBE7F2'}, {}, {}, {}, {}, {}],
        ['1', 'Установка одного коллекторного узла', `шт`, `1`, `1500`, `1500`],
        ['2', 'Монтаж водосчетчика', `шт`, `2`, `950`, `${2*950}`],
        ['3', 'Разводка труб водоснабжения (на тройниках)', `в/ розетка`, `${numbers*2}`,`2300`, `${numbers*2300}`],
        ['4', 'Разводка фановых (канализационных) труб ПВХ', `точка`, `${numbers}`,`700`, `${numbers * 700}`],
    ] : [[{colSpan: 6, rowSpan: 5, text: 'Прокладка труб: нет'}, {},{},{},{},{}],['', '','','','','',], ['', '','','','','',], ['', '','','','','',], ['', '','','','','',]];

    let bathtubWorks =  bathtubBool ? ['*', 'Установка и подключение ванны', `шт`, `${bathtubNumLet}`, `2900`, `${bathtubNumLet*2900}`] : [{colSpan: 6, text: 'Установка и подключение ванны: нет'}, {},{},{},{},{}];

    let showerCabinWorks =  showerCabinBool ? ['*', 'Установка и подключение душевой кабины', `шт`, `${showerCabinNumLet}`, `6000`, `${showerCabinNumLet*6000}`] : [{colSpan: 6, text: 'Установка и подключение душевой кабины: нет'}, {},{},{},{},{}];

    let palletWorks =  palletBool ? ['*', 'Установка и подключение душевой кабины', `шт`, `${palletNumLet}`, `9000`, `${palletNumLet*9000}`] : [{colSpan: 6, text: 'Установка и подключение душевой кабины: нет'}, {},{},{},{},{}];

    let showerHeadWorks =  showerHeadBool ? ['*', 'Установка душевой лейки (наружной)', `шт`, `${showerHeadNumLet}`, `1200`, `${showerHeadNumLet*1200}`] : [{colSpan: 6, text: 'Установка душевой лейки (наружной): нет'}, {},{},{},{},{}];

    let dishwasherWorks =  dishwasherBool ? ['*', 'Установка и подключение посудомоечной машины', `шт`, `${dishwasherNumberLet}`, `1200`, `${dishwasherNumberLet*1200}`] : [{colSpan: 6, text: 'Установка и подключение посудомоечной машины: нет'}, {},{},{},{},{}];

    let sinkWorks =  sinkBool ? ['*', 'Монтаж раковины', `шт`, `${sinkNumberLet}`, `1400`, `${sinkNumberLet*1400}`] : [{colSpan: 6, text: 'Монтаж раковины: нет'}, {},{},{},{},{}];

    let hygienicShowerWorks =  hygienicShowerBool ? ['*', 'Монтаж гигиенического душа', `шт`, `${hygienicShowerNumberLet}`, `1200`, `${hygienicShowerNumberLet*1200}`] : [{colSpan: 6, text: 'Монтаж гигиенического душа: нет'}, {},{},{},{},{}];

    let tapWorks =  tapBool ? ['*', 'Установка стандартного смесителя', `шт`, `${tapNumberLet}`, `900`, `${tapNumberLet*900}`] : [{colSpan: 6, text: 'Установка стандартного смесителя: нет'}, {},{},{},{},{}];
    
    let toiletWorks =  toiletBool ? ['*', 'Установка и подключение унитаза стандартного', `шт`, `${toiletNumberLet}`, `1800`, `${toiletNumberLet*1800}`] : [{colSpan: 6, text: 'Установка и подключение унитаза стандартного: нет'}, {},{},{},{},{}];

    let dryerWorks =  dryerBool ? ['*', 'Монтаж п/сушителя', `шт`, `${dryerNumberLet}`, `2400`, `${dryerNumberLet*2400}`] : [{colSpan: 6, text: 'Монтаж п/сушителя: нет'}, {},{},{},{},{}];

    let washerWarks =  washerBool ? ['*', 'Установка и подключение стиральной машины', `шт`, `${washerNumberLet}`, `1600`, `${washerNumberLet*1600}`] : [{colSpan: 6, text: 'Установка и подключение стиральной машины: нет'}, {},{},{},{},{}];

    let plumberTotal = getTotal('Сантехнические работы:', plumbingTotalLet);
  
    return {
    content: [
        {
        style: 'tableExample',
        color: '#444',
        table: {
            widths: [53, 100, 53, 100, 53, 100],
            headerRows: 2,
            // keepWithHeaderRows: 1,
            body: [
                [{text: `Имя: ${nameLet}`, colSpan: 3}, {}, {}, {text: `Телефон: ${telLet}`, colSpan: 3},  {}, {}],
                [{text: `Примерная смета по калькуляции ООО "Знак качества"`, style: 'tableHeader', colSpan: 6, alignment: 'center', color: '#1261AB', bold: true}, {}, {}, {}, {}, {}],
                [{text: `Замерщик:`, style: 'tableHeader', colSpan: 6, alignment: 'left'}, {}, {}, {}, {}, {}], 
            ]
        }   
        },
         // Kitchen
         kitchenLet && {
            style: 'tableExample',
            color: '#444',
            table: {
                widths: ['auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
                headerRows: 2,
                // keepWithHeaderRows: 1,
                body: [
                    [{text: `Кухня`, colSpan: 6, alignment: 'center', fillColor: '#1261AB', color: 'white', bold: true}, {}, {}, {}, {}, {}],
                    [{text: '№', style: 'tableHeader', alignment: 'center', color: '#1261AB', bold: true}, {text: 'Наименование работ', style: 'tableHeader', alignment: 'center', color: '#1261AB', bold: true}, {text: 'Ед. изм ', style: 'tableHeader', alignment: 'center', color: '#1261AB', bold: true}, {text: 'Кол-во', style: 'tableHeader', alignment: 'center', color: '#1261AB', bold: true}, {text: 'Цена за ед.', style: 'tableHeader', alignment: 'center', color: '#1261AB', bold: true}, {text: 'Цена общ.', style: 'tableHeader', alignment: 'center', color: '#1261AB', bold: true}],
                    [{text: `Пол: ${florAreaKitchen} м2`, colSpan: 6, alignment: 'center', fillColor: '#8BA3BA',  bold: true, color: 'black'}, {}, {}, {}, {}, {}],
                    floorBlakWorksKitchen[0],
                    floorBlakWorksKitchen[1],
                    floorBlakWorksKitchen[2],
                    floorBlakWorksKitchen[3],
                    floorBlakWorksKitchen[4],
                    floorWhiteWorksKitchen[0],
                    floorWhiteWorksKitchen[1],
                    floorWhiteWorksKitchen[2],
                    floorFlooringWorksKitchen[0],
                    floorFlooringWorksKitchen[1],
                    floorFlooringWorksKitchen[2],
                    floorFlooringWorksKitchen[3],
                    floorFlooringWorksKitchen[4],
                    floorFlooringWorksKitchen[5],
                    floorFlooringWorksKitchen[6],
                    floorFlooringWorksKitchen[7],
                    floorFlooringWorksKitchen[8],
                    floorFlooringWorksKitchen[9],
                    floorFlooringWorksKitchen[10],
                    floorFlooringWorksKitchen[11],
                    floorFlooringWorksKitchen[12],
                    floorFlooringWorksKitchen[13],
                    [{text: `Стены: ${walsAreaKtchen} м2`, style: 'tableHeader', colSpan: 6, alignment: 'center', fillColor: '#8BA3BA',  bold: true, color: 'black'}, {}, {}, {}, {}, {}],
                    walsBlackWorksKitchen[0],
                    walsBlackWorksKitchen[1],
                    walsBlackWorksKitchen[2],
                    walsBlackWorksKitchen[3],
                    walsBlackWorksKitchen[4],
                    walsBlackWorksKitchen[5],
                    walsBlackWorksKitchen[6],
                    walsBlackWorksKitchen[7],
                    walsWhiteWorksKitchen[0],
                    walsWhiteWorksKitchen[1],
                    walsWhiteWorksKitchen[2],
                    walsWhiteWorksKitchen[3],
                    walsWhiteWorksKitchen[4],
                    walsWhiteWorksKitchen[5],
                    walsWhiteWorksKitchen[6],
                    walsWhiteWorksKitchen[7],
                    walsWhiteWorksKitchen[8],
                    walsfinisWorksKitchen[0],
                    walsfinisWorksKitchen[1],
                    walsfinisWorksKitchen[2],
                    walsfinisWorksKitchen[3],
                    walsfinisWorksKitchen[4],
                    [{text: `Потолок: ${ceilingAreaKitchen} м2`, style: 'tableHeader', colSpan: 6, alignment: 'center', fillColor: '#8BA3BA',  bold: true, color: 'black'}, {}, {}, {}, {}, {}],
                    ceilingBlackWorksKitchen[0],
                    ceilingBlackWorksKitchen[1],
                    ceilingBlackWorksKitchen[2],
                    ceilingBlackWorksKitchen[3],
                    ceilingBlackWorksKitchen[4],
                    ceilingBlackWorksKitchen[5],
                    ceilingBlackWorksKitchen[6],
                    ceilingBlackWorksKitchen[7],
                    ceilingBlackWorksKitchen[8],
                    ceilingBlackWorksKitchen[9],
                    ceilingBlackWorksKitchen[10],
                    ceilingWhitekWorksKitchen[0],
                    ceilingWhitekWorksKitchen[1],
                    ceilingWhitekWorksKitchen[2],
                    ceilingWhitekWorksKitchen[3],
                    ceilingWhitekWorksKitchen[4],
                    ceilingWhitekWorksKitchen[5],
                    ceilingWhitekWorksKitchen[6],
                    ceilingWhitekWorksKitchen[7],
                    ceilingPaintingkWorksKitchen[0],
                    ceilingPaintingkWorksKitchen[1],
                    kitchenTotal
                ]
            }   
        },
        // rooms
        roomLet && {
            style: 'tableExample',
            color: '#444',
            table: {
                widths: ['auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
                headerRows: 2,
                // keepWithHeaderRows: 1,
                body: [
                    [{text: `Комнаты`, colSpan: 6, alignment: 'center', fillColor: '#1261AB', color: 'white', bold: true}, {}, {}, {}, {}, {}],
                    [{text: '№', style: 'tableHeader', alignment: 'center', color: '#1261AB', bold: true}, {text: 'Наименование работ', style: 'tableHeader', alignment: 'center', color: '#1261AB', bold: true}, {text: 'Ед. изм ', style: 'tableHeader', alignment: 'center', color: '#1261AB', bold: true}, {text: 'Кол-во', style: 'tableHeader', alignment: 'center', color: '#1261AB', bold: true}, {text: 'Цена за ед.', style: 'tableHeader', alignment: 'center', color: '#1261AB', bold: true}, {text: 'Цена общ.', style: 'tableHeader', alignment: 'center', color: '#1261AB', bold: true}],
                    [{text: `Количество комнат: ${roomsNumber}`, colSpan: 6, alignment: 'center', fillColor: '#8BA3BA',  bold: true, color: 'black'}, {}, {}, {}, {}, {}],
                    [{text: `Пол: ${allRoomsFloorArea} м2`, colSpan: 6, alignment: 'center', fillColor: '#8BA3BA',  bold: true, color: 'black'}, {}, {}, {}, {}, {}],
                    floorBlakWorksRooms[0],
                    floorBlakWorksRooms[1],
                    floorBlakWorksRooms[2],
                    floorBlakWorksRooms[3],
                    floorBlakWorksRooms[4],
                    floorWhiteWorksRooms[0],
                    floorWhiteWorksRooms[1],
                    floorWhiteWorksRooms[2],
                    floorFlooringWorksRooms[0],
                    floorFlooringWorksRooms[1],
                    floorFlooringWorksRooms[2],
                    floorFlooringWorksRooms[3],
                    floorFlooringWorksRooms[4],
                    floorFlooringWorksRooms[5],
                    floorFlooringWorksRooms[6],
                    floorFlooringWorksRooms[7],
                    floorFlooringWorksRooms[8],
                    floorFlooringWorksRooms[9],
                    floorFlooringWorksRooms[10],
                    floorFlooringWorksRooms[11],
                    floorFlooringWorksRooms[12],
                    floorFlooringWorksRooms[13],
                    [{text: `Стены: ${allRoomsWalsArea} м2`, style: 'tableHeader', colSpan: 6, alignment: 'center', fillColor: '#8BA3BA',  bold: true, color: 'black'}, {}, {}, {}, {}, {}],
                    walsBlackWorksRooms[0],
                    walsBlackWorksRooms[1],
                    walsBlackWorksRooms[2],
                    walsBlackWorksRooms[3],
                    walsBlackWorksRooms[4],
                    walsBlackWorksRooms[5],
                    walsBlackWorksRooms[6],
                    walsBlackWorksRooms[7],
                    walsWhiteWorksRooms[0],
                    walsWhiteWorksRooms[1],
                    walsWhiteWorksRooms[2],
                    walsWhiteWorksRooms[3],
                    walsWhiteWorksRooms[4],
                    walsWhiteWorksRooms[5],
                    walsWhiteWorksRooms[6],
                    walsWhiteWorksRooms[7],
                    walsWhiteWorksRooms[8],
                    walsfinisWorksRooms[0],
                    walsfinisWorksRooms[1],
                    walsfinisWorksRooms[2],
                    walsfinisWorksRooms[3],
                    walsfinisWorksRooms[4],
                    [{text: `Потолок: ${allRoomsCeilingArea} м2`, style: 'tableHeader', colSpan: 6, alignment: 'center', fillColor: '#8BA3BA',  bold: true, color: 'black'}, {}, {}, {}, {}, {}],
                    ceilingBlackWorksRooms[0],
                    ceilingBlackWorksRooms[1],
                    ceilingBlackWorksRooms[2],
                    ceilingBlackWorksRooms[3],
                    ceilingBlackWorksRooms[4],
                    ceilingBlackWorksRooms[5],
                    ceilingBlackWorksRooms[6],
                    ceilingBlackWorksRooms[7],
                    ceilingBlackWorksRooms[8],
                    ceilingBlackWorksRooms[9],
                    ceilingBlackWorksRooms[10],
                    ceilingWhitekWorksRooms[0],
                    ceilingWhitekWorksRooms[1],
                    ceilingWhitekWorksRooms[2],
                    ceilingWhitekWorksRooms[3],
                    ceilingWhitekWorksRooms[4],
                    ceilingWhitekWorksRooms[5],
                    ceilingWhitekWorksRooms[6],
                    ceilingWhitekWorksRooms[7],
                    ceilingPaintingkWorksRooms[0],
                    ceilingPaintingkWorksRooms[1],
                    roomsTotal
                ]
            }   
        },
        // hall
        hallLet && {
            style: 'tableExample',
            color: '#444',
            table: {
                widths: ['auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
                headerRows: 2,
                // keepWithHeaderRows: 1,
                body: [
                    [{text: `Коридор`, colSpan: 6, alignment: 'center', fillColor: '#1261AB', color: 'white', bold: true}, {}, {}, {}, {}, {}],
                    [{text: '№', style: 'tableHeader', alignment: 'center', color: '#1261AB', bold: true}, {text: 'Наименование работ', style: 'tableHeader', alignment: 'center', color: '#1261AB', bold: true}, {text: 'Ед. изм ', style: 'tableHeader', alignment: 'center', color: '#1261AB', bold: true}, {text: 'Кол-во', style: 'tableHeader', alignment: 'center', color: '#1261AB', bold: true}, {text: 'Цена за ед.', style: 'tableHeader', alignment: 'center', color: '#1261AB', bold: true}, {text: 'Цена общ.', style: 'tableHeader', alignment: 'center', color: '#1261AB', bold: true}],
                    [{text: `Пол: ${florAreaHall} м2`, colSpan: 6, alignment: 'center', fillColor: '#8BA3BA',  bold: true, color: 'black'}, {}, {}, {}, {}, {}],
                    floorBlakWorksHall[0],
                    floorBlakWorksHall[1],
                    floorBlakWorksHall[2],
                    floorBlakWorksHall[3],
                    floorBlakWorksHall[4],
                    floorWhiteWorksHall[0],
                    floorWhiteWorksHall[1],
                    floorWhiteWorksHall[2],
                    floorFlooringWorksHall[0],
                    floorFlooringWorksHall[1],
                    floorFlooringWorksHall[2],
                    floorFlooringWorksHall[3],
                    floorFlooringWorksHall[4],
                    floorFlooringWorksHall[5],
                    floorFlooringWorksHall[6],
                    floorFlooringWorksHall[7],
                    floorFlooringWorksHall[8],
                    floorFlooringWorksHall[9],
                    floorFlooringWorksHall[10],
                    floorFlooringWorksHall[11],
                    floorFlooringWorksHall[12],
                    floorFlooringWorksHall[13],
                    [{text: `Стены: ${walsAreHall} м2`, style: 'tableHeader', colSpan: 6, alignment: 'center', fillColor: '#8BA3BA',  bold: true, color: 'black'}, {}, {}, {}, {}, {}],
                    walsBlackWorksHall[0],
                    walsBlackWorksHall[1],
                    walsBlackWorksHall[2],
                    walsBlackWorksHall[3],
                    walsBlackWorksHall[4],
                    walsBlackWorksHall[5],
                    walsBlackWorksHall[6],
                    walsBlackWorksHall[7],
                    walsWhiteWorksHall[0],
                    walsWhiteWorksHall[1],
                    walsWhiteWorksHall[2],
                    walsWhiteWorksHall[3],
                    walsWhiteWorksHall[4],
                    walsWhiteWorksHall[5],
                    walsWhiteWorksHall[6],
                    walsWhiteWorksHall[7],
                    walsWhiteWorksHall[8],
                    walsfinisWorksHall[0],
                    walsfinisWorksHall[1],
                    walsfinisWorksHall[2],
                    walsfinisWorksHall[3],
                    walsfinisWorksHall[4],
                    [{text: `Потолок: ${ceilingAreaHall} м2`, style: 'tableHeader', colSpan: 6, alignment: 'center', fillColor: '#8BA3BA',  bold: true, color: 'black'}, {}, {}, {}, {}, {}],
                    ceilingBlackWorksHall[0],
                    ceilingBlackWorksHall[1],
                    ceilingBlackWorksHall[2],
                    ceilingBlackWorksHall[3],
                    ceilingBlackWorksHall[4],
                    ceilingBlackWorksHall[5],
                    ceilingBlackWorksHall[6],
                    ceilingBlackWorksHall[7],
                    ceilingBlackWorksHall[8],
                    ceilingBlackWorksHall[9],
                    ceilingBlackWorksHall[10],
                    ceilingWhitekWorksHall[0],
                    ceilingWhitekWorksHall[1],
                    ceilingWhitekWorksHall[2],
                    ceilingWhitekWorksHall[3],
                    ceilingWhitekWorksHall[4],
                    ceilingWhitekWorksHall[5],
                    ceilingWhitekWorksHall[6],
                    ceilingWhitekWorksHall[7],
                    ceilingPaintingkWorksHall[0],
                    ceilingPaintingkWorksHall[1],
                    hallTotal
                ]
            }   
        },
        // bath
        bathroomLet && {
            style: 'tableExample',
            color: '#444',
            table: {
                widths: ['auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
                headerRows: 2,
                // keepWithHeaderRows: 1,
                body: [
                    [{text: `Ванная и туалет`, colSpan: 6, alignment: 'center', fillColor: '#1261AB', color: 'white', bold: true}, {}, {}, {}, {}, {}],
                    [{text: '№', style: 'tableHeader', alignment: 'center', color: '#1261AB', bold: true}, {text: 'Наименование работ', style: 'tableHeader', alignment: 'center', color: '#1261AB', bold: true}, {text: 'Ед. изм ', style: 'tableHeader', alignment: 'center', color: '#1261AB', bold: true}, {text: 'Кол-во', style: 'tableHeader', alignment: 'center', color: '#1261AB', bold: true}, {text: 'Цена за ед.', style: 'tableHeader', alignment: 'center', color: '#1261AB', bold: true}, {text: 'Цена общ.', style: 'tableHeader', alignment: 'center', color: '#1261AB', bold: true}],
                    [{text: `Пол: ${floorAreaBath} м2`, colSpan: 6, alignment: 'center', fillColor: '#8BA3BA',  bold: true, color: 'black'}, {}, {}, {}, {}, {}],
                    floorBlakWorksBath[0],
                    floorBlakWorksBath[1],
                    floorBlakWorksBath[2],
                    floorBlakWorksBath[3],
                    floorBlakWorksBath[4],
                    floorWhiteWorksBath[0],
                    floorWhiteWorksBath[1],
                    floorWhiteWorksBath[2],
                    floorWhiteWorksBath[3],
                    floorFlooringWorksBath[0],
                    floorFlooringWorksBath[1],
                    floorFlooringWorksBath[2],
                    [{text: `Стены: ${wallsAreaBath} м2`, style: 'tableHeader', colSpan: 6, alignment: 'center', fillColor: '#8BA3BA',  bold: true, color: 'black'}, {}, {}, {}, {}, {}],
                    wallsBlackWorksBath[0],
                    wallsBlackWorksBath[1],
                    wallsBlackWorksBath[2],
                    wallsBlackWorksBath[3],
                    wallsFinishingWorksBath[0],
                    wallsFinishingWorksBath[1],
                    wallsFinishingWorksBath[2],
                    [{text: `Потолок: ${ceilingAreaBath} м2`, style: 'tableHeader', colSpan: 6, alignment: 'center', fillColor: '#8BA3BA',  bold: true, color: 'black'}, {}, {}, {}, {}, {}],
                    ceilingWorksBath[0],
                    ceilingWorksBath[1],
                    ceilingWorksBath[2],
                    ceilingWorksBath[3],
                    ceilingWorksBath[4],
                    ceilingWorksBath[5],
                    ceilingWorksBath[6],
                    ceilingWorksBath[7],
                    ceilingWorksBath[8],
                    ceilingWorksBath[9],
                    ceilingWorksBath[10],
                    ceilingWorksBath[11],
                    bathTotal
                ]
            }   
        },
        // electric
        electricaLet && {
            style: 'tableExample',
            color: '#444',
            table: {
                widths: ['auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
                headerRows: 2,
                // keepWithHeaderRows: 1,
                body: [
                    [{text: `Электромонтажные работы`, colSpan: 6, alignment: 'center', fillColor: '#1261AB', color: 'white', bold: true}, {}, {}, {}, {}, {}],
                    [{text: '№', style: 'tableHeader', alignment: 'center', color: '#1261AB', bold: true}, {text: 'Наименование работ', style: 'tableHeader', alignment: 'center', color: '#1261AB', bold: true}, {text: 'Ед. изм ', style: 'tableHeader', alignment: 'center', color: '#1261AB', bold: true}, {text: 'Кол-во', style: 'tableHeader', alignment: 'center', color: '#1261AB', bold: true}, {text: 'Цена за ед.', style: 'tableHeader', alignment: 'center', color: '#1261AB', bold: true}, {text: 'Цена общ.', style: 'tableHeader', alignment: 'center', color: '#1261AB', bold: true}],
                    panelElecticaWorks[0],
                    panelElecticaWorks[1],
                    panelElecticaWorks[2],
                    panelElecticaWorks[3],
                    socketsAndSocketsWorks[0],
                    socketsAndSocketsWorks[1],
                    socketsAndSocketsWorks[2],
                    socketsAndSocketsWorks[3],
                    socketsAndSocketsWorks[4],
                    socketsAndSocketsWorks[5],
                    lightnessWorks[0],
                    lightnessWorks[1],
                    lightnessWorks[2],
                    lightnessWorks[3],
                    lightnessWorks[4],
                    electricTotal
                ]
            }   
        },

        // plumbing
        plumbingLet && {
            style: 'tableExample',
            color: '#444',
            table: {
                widths: ['auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
                headerRows: 2,
                // keepWithHeaderRows: 1,
                body: [
                    [{text: `Сантехнические работы`, colSpan: 6, alignment: 'center', fillColor: '#1261AB', color: 'white', bold: true}, {}, {}, {}, {}, {}],
                    [{text: '№', style: 'tableHeader', alignment: 'center', color: '#1261AB', bold: true}, {text: 'Наименование работ', style: 'tableHeader', alignment: 'center', color: '#1261AB', bold: true}, {text: 'Ед. изм ', style: 'tableHeader', alignment: 'center', color: '#1261AB', bold: true}, {text: 'Кол-во', style: 'tableHeader', alignment: 'center', color: '#1261AB', bold: true}, {text: 'Цена за ед.', style: 'tableHeader', alignment: 'center', color: '#1261AB', bold: true}, {text: 'Цена общ.', style: 'tableHeader', alignment: 'center', color: '#1261AB', bold: true}],
                    tubingBoolWorks[0],
                    tubingBoolWorks[1],
                    tubingBoolWorks[2],
                    tubingBoolWorks[3],
                    tubingBoolWorks[4],
                    bathtubWorks,
                    showerCabinWorks,
                    palletWorks,
                    showerHeadWorks,
                    dishwasherWorks,
                    sinkWorks, 
                    hygienicShowerWorks,
                    tapWorks,
                    toiletWorks,
                    dryerWorks,
                    washerWarks,
                    plumberTotal
                ]
            }   
        }
    ]
}
}

export default getDd;

